import React from 'react';
import Formwizard2Container from '../../../Componant/Forms/FormLayout/FormWizard2';

const FormWizardTwo = () => {
  return (
    <div className='page-body'>
      <Formwizard2Container />
    </div>
  );
};

export default FormWizardTwo;
